var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 14.18C1.75 14.3737 1.81836 14.5332 2.00065 14.7155L5.6237 18.4411C5.77181 18.5778 5.91992 18.6576 6.11361 18.6576C6.48958 18.6576 6.76302 18.3613 6.76302 17.9854C6.76302 17.8031 6.69466 17.6094 6.54655 17.484L4.71224 15.7295L3.81217 14.8636L5.38444 14.9206L17.0853 14.9206C17.4841 14.9206 17.8145 14.5788 17.8145 14.18C17.8145 13.7812 17.4841 13.4508 17.0853 13.4508L5.38444 13.4508L3.80078 13.5078L4.71224 12.6305L6.54655 10.876C6.69466 10.7393 6.76302 10.5456 6.76302 10.3633C6.76302 9.97591 6.48958 9.70247 6.11361 9.70247C5.91992 9.70247 5.77181 9.77083 5.6237 9.91894L2.00065 13.6445C1.81836 13.8268 1.75 13.9977 1.75 14.18ZM26.4847 20.3665C26.4847 22.5312 25.4023 23.625 23.2604 23.625H12.3571C10.2266 23.625 9.14421 22.5312 9.14421 20.3665V17.3245H10.6253V20.3438C10.6253 21.5059 11.2406 22.1325 12.4368 22.1325H23.1807C24.377 22.1325 24.9922 21.5059 24.9922 20.3438V8.02767C24.9922 6.88834 24.377 6.22754 23.1807 6.22754H12.4368C11.2406 6.22754 10.6253 6.88834 10.6253 8.02767L10.6253 11.0355H9.14421V7.99349C9.14421 5.82877 10.238 4.74642 12.3571 4.74642H23.2604C25.3909 4.74642 26.4847 5.82877 26.4847 7.99349V20.3665Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5f0b3c045f5cdf5e1b7befe61c0fba64.svg";
export { ForwardRef as ReactComponent };